/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TimePicker from 'react-time-picker';
import { fetchSetting, setSetting } from '../../Components/action/common';
import { pushToSetting } from '../../redux/slices/SettingSclice';
import { AIChatGredientIcon } from '../../Components/LandingHeader/Feedback/icons/Icons';

const Rituals = ({ activeTab, setActiveTab }) => {
    const { theme, colorPicker, colorPickerDark } = useSelector(state => state.theme);
    const {settings} = useSelector(state => state.settings);
    const dispatch = useDispatch();

    useEffect(() => {
        fetchSettingData();
    }, [])

    const fetchSettingData = async () => {
        try {
          let response = await fetchSetting()
          dispatch(pushToSetting(response?.data?.responseData?.settings));
        } catch ({ response }) {}
    }

    const handleChange = async (value, name) => {
        const newSettings = { ...settings, [name]: value };
        dispatch(pushToSetting(newSettings));
        try {
          await setSetting({ "settings": newSettings })
        } catch ({ response }) { }
    }
    
    return (
        <li
            css={{
                '&:hover .accordion-title': {
                color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c")) ? "white !important" : (theme == "dark" && colorPickerDark == "#f8961e") ? "black !important" : (theme == "dark" && colorPickerDark == "#ffca3a") ? "black !important" : (theme == "dark" && colorPickerDark == "#27cb9a") ? "black !important" : (theme == "dark" && colorPickerDark == "#4cc9f0") ? "black !important" : "white !important") : "white !important"
                },
                '.accordion-title': {
                color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c") && (activeTab == "rituals")) ? "white !important" : ((theme == "dark" && colorPickerDark == "#f8961e") && (activeTab == "rituals")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#ffca3a") && (activeTab == "rituals")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#27cb9a") && (activeTab == "rituals")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#4cc9f0") && (activeTab == "rituals")) ? "black !important" : "white !important") : "white"
                }
            }}
            className={`li-setting-tab ${activeTab == "rituals" ? 'active' : ''}`}>
            <div className="settings-accordion-tab"
                onClick={() => { setActiveTab(activeTab => activeTab == 'rituals' ? null : 'rituals'); }}
                style={{ background: theme == "dark" ? "black" : "" }}
                css={{
                    background: activeTab == 'rituals' ? (theme == 'dark' ? `linear-gradient(0deg,var(--accent-color-10),var(--accent-color-10)),#000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`) :
                        '',
                    '&:hover': {
                        background: theme == 'dark' ? `linear-gradient(0deg, var(--accent-color-10), var(--accent-color-10)), #000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`,
                    }
                }}>
                <div className="settings-accordion-heading">
                <figure className="settings-icon">
                <AIChatGredientIcon width="18" height="18" color="rgba(0, 0, 0, 0.3)" customClass="img-default dark:invert-color" />
                </figure>
                <h3 className="accordion-title uppercase dark:text-white">RITUALS</h3>
                </div>
                <div className="settings-accordion-arrow">
                    <img src="/images/arrow-down.svg" className="dark:invert-color" />
                </div>
            </div>
            {
                activeTab == 'rituals' 
                && 
                <div className="settings-accordion-content">
                    <div className="inner-form relative">
                        <label className="field-label font text-black mb-0">Schedule</label>
                        <div className="block-field-info font text-secondary text-base mb-0">Choose when you'd like your daily rituals to begin. At the set times, your new tab will be replaced with a prompt to guide your ritual.</div>

                        <div className="field-block mt-[30px]">
                            <label className="field-label flex items-center gap-5 !mb-0 dark:text-white dark:opacity-70">
                                Morning
                                <div class="on-off-toggle" >
                                    <input class="on-off-toggle__input" type="checkbox" id={`ritualMorning`} onChange={(e) => handleChange(e.target.checked ? 1 : 0, "ritualMorning")} defaultChecked={settings?.ritualMorning ? true : false} />

                                    <label for={`ritualMorning`} className="on-off-toggle__slider focus-label"
                                      css={{
                                        background: !settings?.ritualMorning ? `linear-gradient(0deg,rgba(0,0,0,0.8),rgba(0,0,0,0.8)),linear-gradient(0deg,${theme == "dark" ? colorPickerDark : colorPicker},${theme == "dark" ? colorPickerDark : colorPicker}),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05)),#000000 !important` : `${theme == "dark" ? colorPickerDark : colorPicker} !important`
                                      }}
                                    ></label>
                                </div>
                            </label>
                            <div className="block-field-info font text-secondary text-base">Start your day with intention. You’ll be prompted to journal and plan your focus for the day ahead.</div>
                            <div className="filed-data-block field-data" css={{
                                '.react-time-picker': {
                                    width: '200px !important'
                                }
                            }}>
                                <TimePicker
                                    onChange={ritualMorningTime => handleChange(ritualMorningTime, 'ritualMorningTime')}
                                    value={settings?.ritualMorningTime}
                                    disableClock={true}
                                    isOpen={false}
                                    format="h:mm a"
                                    className={theme == 'dark' ? 'custom-input-select-dark' : ""}
                                />
                            </div>
                        </div>
                        <div className="field-block mt-[30px]">
                            <label className="field-label flex items-center gap-5 !mb-0 dark:text-white dark:opacity-70">
                                Evening
                            </label>
                            <div className="block-field-info font text-secondary text-base">Wind down with reflection. Capture your thoughts and review your day.</div>
                            <div className="filed-data-block field-data" css={{
                                '.react-time-picker': {
                                    width: '200px !important'
                                }
                            }}>
                                <TimePicker
                                    onChange={ritualEveningTime => handleChange(ritualEveningTime, 'ritualEveningTime')}
                                    value={settings?.ritualEveningTime}
                                    disableClock={true}
                                    isOpen={false}
                                    format="h:mm a"
                                    className={theme == 'dark' ? 'custom-input-select-dark' : ""}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </li>
    )
}

export default Rituals